import React from "react";
import SectionShell from "../../shared/SectionShell";

const StudentHistoryTab = ({
  formData,
  handleChange,
  fieldGridStyle,
  cardStyle,
  labelStyle,
  textareaStyle,
}) => {
  return (
    <SectionShell
      title="Academic / Enrollment History"
      subtitle="Previous schools, academic notes, and enrollment background."
    >
      <div style={fieldGridStyle}>
        <div style={cardStyle}>
          <div style={labelStyle}>Previous School</div>
          <textarea
            style={textareaStyle}
            value={formData.previousSchool || ""}
            onChange={(e) => handleChange("previousSchool", e.target.value)}
            placeholder="Enter previous school information"
          />
        </div>

        <div style={cardStyle}>
          <div style={labelStyle}>Academic History</div>
          <textarea
            style={textareaStyle}
            value={formData.academicHistory || ""}
            onChange={(e) => handleChange("academicHistory", e.target.value)}
            placeholder="Enter academic notes or background"
          />
        </div>
      </div>
    </SectionShell>
  );
};

export default StudentHistoryTab;